export const styles = theme => ({
  textField: {
    width: 'calc(100% - 30px)',
    marginLeft: 15,
    marginRight: 15,
  },
  textFieldFromTableWithTime: {
    width: 185,
    marginBottom: 0,
    marginTop: 0,
  },
  textFieldFromTable: {
    width: 145,
    marginBottom: 0,
    marginTop: 0,
  },
  textFieldFullWidth: {
    width: '100%',
  },
})
